import { View }     from 'backbone';
import { Model }    from 'backbone';
import selectFormOrReportModalView  from 'common-views/SelectFormOrReportModalView.js';
import _            from 'lodash';
import eventBus     from 'EventBus.js';
import widgetUtil   from 'util/WidgetUtil.js';
import formatTemplate   from 'properties/main/select_form_or_report.ejs';  
import util from 'util/Util.js'; 
import constants from 'Constants.js';

class MainSelectFormOrReportView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.config = this.options.config || {mode: 'form', modelField:'formOrReport'};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.modelField = opts.modelField || 'formOrReport';
        this.events = {
            "click #selectForm"     : "showSelectModal"
        };

        // Add needed property
        switch(this.config.mode){
            case 'form':
                this.model.set('sectionTitle', 'Show App Settings', {silent: true});
                //this.model.set('formOrReport', this.model.get('selectedForm'), {silent: true});
                break;
            case 'report':
                this.model.set('sectionTitle', 'Show Report Settings', {silent: true});
                //this.model.set('formOrReport', this.model.get('selectedReport'), {silent: true});
                this.config.mode = 'report';
                break;
            case 'both':
                this.model.set('sectionTitle', 'App and Report', {silent: true});
                this.config.mode = 'both';
                break;
            default:
               throw "Unsupported mode";
        }

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }  

        return this;
    }

    showSelectModal(ev) {
        ev.preventDefault();
        let checkForInstances = !(this.model.get('factoryKey') === 'command_show_form' ||
            this.model.get('factoryKey') === 'command_show_report' ||
            this.model.get('factoryKey') === 'command_set_field_in_other' ||
            this.model.get('factoryKey') === 'command_get_field_from_other' ||
            this.model.get('factoryKey') === 'control_play_form_button' ||
            this.model.get('factoryKey') === 'control_play_report_button');

        let publishedInstances = this.model.get('factoryKey') === 'command_show_form' ||
            this.model.get('factoryKey') === 'command_show_report' ||
            this.model.get('factoryKey') === 'command_set_field_in_other' ||
            this.model.get('factoryKey') === 'command_get_field_from_other'||
            this.model.get('factoryKey') === 'control_play_form_button' ||
            this.model.get('factoryKey') === 'control_play_report_button';

        // PF-1857 Adding extra condition for selecting a form with instances.
        let selectableFormWithInstances =
            this.model.get('factoryKey') === 'control_play_form_button' ||
            this.model.get('factoryKey') === 'control_play_report_button';

        let sfModal = new selectFormOrReportModalView(
            {
                model: new Model(),
                mode: this.config.mode,
                checkForInstances: checkForInstances,
                publishedInstances: publishedInstances,
                selectableFormWithInstances:selectableFormWithInstances
            });

        sfModal.render().then((selectedFormOrReport)=>{
            if (this.config.mode === 'form') {
                this.model.set('formGUID', selectedFormOrReport.GUID, {silent: true});
                this.model.set('formName', selectedFormOrReport.name, {silent: true});
                // this needs to NOT be silent so it triggers the model in another view.
                this.model.set('formId', selectedFormOrReport.id,{silent:true});
                eventBus.trigger('FORM_ID_CHANGED_' + this.model.get('id'));
            } else {
                this.model.set('reportId', selectedFormOrReport.id, {silent: true});
                this.model.set('reportGUID', selectedFormOrReport.GUID, {silent: true});
                this.model.set('reportName', selectedFormOrReport.name, {silent: true});
            }
            this.model.set('linkId', selectedFormOrReport.linkId, {silent: true});
            this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ) ;
            this.render();
        }).catch(err => console.log(err));
    }

    getViewData(){
        return _.merge(this.model.toJSON(), {formOrReportName:this.model.get(this.config.modelField) || '' });
    }

    render() {
        this.$el.empty();
        if(this.template) {
            $(this.$el[0]).html(this.template(this.getViewData()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainSelectFormOrReportView;
